import * as types from "./mutation-types";
import initialState from "./state";

export const mutations = {
  [types.SET_SEARCH_QUERY](state, payload) {
    state.filters.searchQuery = payload;
  },
  [types.SET_NOTIFICATIONS](state, payload) {
    state.notifications = payload;
  },
  [types.SET_NOTIFICATION_STATE](state, payload) {
    state.currentNotification = payload;
  },
  [types.RESET_CURRENT_NOTIFICATION](state) {
    state.currentNotification = initialState;
  },
  [types.SET_RESULT_COUNT](state, number) {
    state.filters.size = number;
    state.pagination.per_page = number;
    state.pagination.total = number;
    state.pagination.to = number;
  },

  [types.SET_FILTER_TOTAL](state, total) {
    state.pagination.total = total;
    state.pagination.last_page = Math.ceil(total / state.pagination.per_page);
  },

  [types.SET_CURRENT_PAGE](state, page) {
    state.pagination.current_page = page;
  },
  [types.SET_FILTER_CATEGORY](state, categories) {
    state.filters.categories = categories;
  },
};
